import React, { useEffect } from 'react';
import { useEditor, useNode, Element } from '@craftjs/core';
import { defaultToolSettings } from '../../../../features/forms/base/controls/inputs/base/baseControlSettings';
import { useContextSelector } from 'use-context-selector';
import { CalculatedBlock } from '../Containers/CalculatedBlock';
import { Container } from '../Containers/Container';
import styles from '../controlsStyle.module.scss';
import { FormFillContext } from '../../uiEditor/provider/formFill.context';
import { IBmiInput } from '../../../../features/forms/base/controls/specials/BmiInput';
import { textInputDefaultPropsFactory } from '../../../../features/forms/base/controls/inputs/TextInput';
import { useScopedTranslation } from '../../../../application/localisation/useScopedTranslation';
import { LayoutSettings } from '../../toolbox/settingsPanel/content/LayoutSettings';
import { NumberInput } from '../Inputs/NumberInput';

/**
 * @deprecated use BmiInputV2 instead
 */
export const BmiInput: IBmiInput = (props) => {
  const { t } = useScopedTranslation('Forms.Controls.BMI');
  const { connectors } = useNode((state) => ({
    selected: state.events.selected,
    dragged: state.events.dragged,
    blockId: state.id,
  }));

  const { connect, drag } = connectors;

  const { size } = {
    ...props,
  };

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const isOnlyView = useContextSelector(FormFillContext, (v) => v.mode === 'Overview');
  const weightValue = useContextSelector(FormFillContext, (v) => (v.values ? v.values.Weight : undefined));
  const heightValue = useContextSelector(FormFillContext, (v) => (v.values ? v.values.Height : undefined));
  const setDataBlockFieldValue = useContextSelector(FormFillContext, (v) => v.setValue);

  useEffect(() => {
    if (isOnlyView) return;

    const weight = Number(weightValue);
    const height = Number(heightValue);
    let bmi;
    if (weight && height) {
      const calc = weight / Math.pow(height / 100, 2);
      bmi = calc < 10 ? undefined : calc.toFixed(1);
      bmi = calc > 999 ? undefined : calc.toFixed(1);
    }

    setDataBlockFieldValue?.('BMI', bmi, { dontTouchField: true });
  }, [weightValue, heightValue, setDataBlockFieldValue, isOnlyView]);

  return (
    <div
      className={styles.container}
      style={{
        width: isOnlyView ? '100%' : size,
      }}
      draggable={enabled}
      ref={(ref) => enabled && connect(drag(ref!))}
    >
      <Element is={Container} id={'BMI_container'} flexBoxGap={20} isFlexBox={true}>
        <Element
          is={NumberInput}
          id={'Weight'}
          {...textInputDefaultPropsFactory()}
          hasSkipCheckBox={props.hasSkipCheckBox}
          dataKey={'Weight'}
          variable={'Weight'}
          size={'100%'}
          label={t('Weight')}
          units={'kg'}
          validation={{ maxValue: 300, isRequired: props.validation.isRequired }}
        />
        <Element
          is={NumberInput}
          id={'Height'}
          {...textInputDefaultPropsFactory()}
          hasSkipCheckBox={props.hasSkipCheckBox}
          dataKey={'Height'}
          variable={'Height'}
          size={'100%'}
          label={t('Height')}
          units={'cm'}
          validation={{ maxValue: 300, isRequired: props.validation.isRequired }}
        />
        <CalculatedBlock isDisabled={true} dataKey={'BMI'} size={'50%'} label={'BMI'} variable={'BMI'} />
      </Element>
    </div>
  );
};

const BmiSettings = () => {
  return <LayoutSettings />;
};

export const BmiDefaultProps = {
  ...defaultToolSettings,
  isMandatory: false,
};

BmiInput.craft = {
  defaultProps: BmiDefaultProps,
  rules: {
    canDrag: () => false,
    canDrop: () => false,
    canMoveIn: () => false,
    canMoveOut: () => false,
  },
  related: {
    settings: BmiSettings,
  },
};
